export function splitPastedText(text: string): string[] {
  const byNewline = text.split('\n');
  const parts = byNewline.length > 1 ? byNewline : text.split(',');
  return parts.map((s) => s.trim()).filter((s) => s !== '');
}
